/* BENLING motion — scroll-triggered reveals. Vanilla JS, no dependencies.
   [data-motion]           rise | left | right | zoom | fade | curtain | draw | words | lines
   [data-motion-stagger]   rise | left | right | pop   (children, or [data-motion-item] inside, appear one by one)
   [data-motion-delay]     seconds added to the start (any of the above) */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = root.classList.contains('is-design-mode');
  var enabled = root.classList.contains('has-reveal') && !reduce.matches && !designMode && 'IntersectionObserver' in window;
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var SKIP = /^(SCRIPT|STYLE|SVG|BUTTON|INPUT|TEXTAREA|SELECT|BR|IMG|VIDEO|IFRAME)$/i;

  function markDone(el, ms) {
    window.setTimeout(function () { el.classList.add('m-done'); }, ms);
  }
  function setBase(el) {
    var d = parseFloat(el.getAttribute('data-motion-delay'));
    if (d) el.style.setProperty('--m-base', d + 's');
  }

  /* ---- text splitting ---------------------------------------------------- */
  function splitWords(el) {
    var words = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'mw';
            var i = document.createElement('span'); i.className = 'mw__i'; i.textContent = part;
            w.appendChild(i); frag.appendChild(w); words.push(i);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !SKIP.test(n.tagName) && !n.classList.contains('mw')) {
          walk(n);
        }
      });
    })(el);
    return words;
  }
  function layoutWords(el, words) {
    var byLine = el.getAttribute('data-motion') === 'lines';
    var line = 0, lastTop = null;
    words.forEach(function (w, idx) {
      var r = w.parentNode.getBoundingClientRect();
      if (lastTop === null) lastTop = r.top;
      else if (Math.abs(r.top - lastTop) > Math.max(4, r.height * 0.5)) { line++; lastTop = r.top; }
      w.style.setProperty('--m-l', byLine ? line : Math.min(idx, 18));
    });
  }

  var textEls = [];
  function initText() {
    $$('[data-motion="words"],[data-motion="lines"]').forEach(function (el) {
      if (el.__mText) return; el.__mText = true;
      if (!enabled) { el.classList.add('is-split', 'm-done'); return; }
      var words = splitWords(el);
      if (!words.length) { el.classList.add('is-split'); return; }
      setBase(el);
      textEls.push({ el: el, words: words });
      layoutWords(el, words);
      el.classList.add('is-split');
      observe(el, function () { markDone(el, 2600 + words.length * 20); });
    });
  }

  /* ---- observer ---------------------------------------------------------- */
  var pending = [];
  var io = enabled ? new IntersectionObserver(function (entries) {
    var batch = entries.filter(function (e) { return e.isIntersecting && e.intersectionRatio >= (e.target.hasAttribute('data-m-item') ? 0.03 : 0.12); }).map(function (e) { return e.target; });
    batch.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; });
    var stagger = 0;
    batch.forEach(function (el) {
      io.unobserve(el);
      if (el.hasAttribute('data-m-item')) {
        el.style.setProperty('--m-i', Math.min(stagger++, 10));
        el.classList.add('is-in');
        markDone(el, 2200 + stagger * 110);
      } else {
        el.classList.add('is-in');
        if (el.__mAfter) el.__mAfter(); else markDone(el, 2600);
      }
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: [0, 0.03, 0.12] }) : null;
  function observe(el, after) { el.__mAfter = after; io.observe(el); }

  /* ---- single elements + groups ----------------------------------------- */
  function initSingles() {
    $$('[data-motion]').forEach(function (el) {
      var kind = el.getAttribute('data-motion');
      if (kind === 'words' || kind === 'lines' || el.__mSingle) return;
      el.__mSingle = true;
      if (!enabled) { el.classList.add('m-done'); return; }
      setBase(el);
      observe(el, null);
    });
  }
  function initGroups() {
    $$('[data-motion-stagger]').forEach(function (group) {
      if (group.__mGroup) return; group.__mGroup = true;
      var effect = group.getAttribute('data-motion-stagger') || 'rise';
      var items = $$('[data-motion-item]', group);
      if (!items.length) items = Array.prototype.slice.call(group.children);
      items.forEach(function (it) {
        if (!enabled) { it.classList.add('m-done'); return; }
        it.setAttribute('data-m-item', '');
        it.setAttribute('data-m-effect', effect);
        setBase(group);
        var base = group.style.getPropertyValue('--m-base');
        if (base) it.style.setProperty('--m-base', base);
        io.observe(it);
      });
    });
  }

  var resizeTimer;
  function relayout() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      textEls.forEach(function (t) { if (t.el.getAttribute('data-motion') === 'lines' && !t.el.classList.contains('m-done')) layoutWords(t.el, t.words); });
    }, 200);
  }

  function init() { initText(); initSingles(); initGroups(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (enabled) {
    window.addEventListener('resize', relayout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { textEls.forEach(function (t) { if (!t.el.classList.contains('m-done')) layoutWords(t.el, t.words); }); });
  }
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('benling:content', init);
})();
